<div id="home-page">
    <div class="cover-photo" style="position: relative; z-index: 3; left: 0; right: 0; height: 200px">
    </div>

    <div class="extra-light-grey-cfa-languedoc-bg" style="position: relative; z-index: 10;">
        <div class="container white-bg" style="position: relative; z-index: 11;">

            <div style="margin-left: -15px; margin-top: -110px !important; position: absolute; z-index: 12;">
                <h1 class="col-12 p-2 bandeau-title white blue-cfa-languedoc-bg font-weight-bold" style="display: table">
                    Offre d'alternance - {{offre.formation}}
                </h1>
                <h2 class="col-12 p-2 bandeau-subtitle brown-2-cfa-languedoc-bg font-weight-bold">
                    {{offre.titre_job}} 
                    <ng-container *ngIf="offre.ville"> à {{offre.ville}}</ng-container>
                </h2>
            </div>    

            <app-contact-candidat [id_instance]="offre.instance_concernee"></app-contact-candidat>

            <div class="row">

                <div class="col-12 col-lg-9 mt-4 px-5">

                    <p class="my-4 blue-cfa-languedoc type-offre">Poste en Alternance dans le cadre du {{offre.formation}} au Centre de Formation du Languedoc :</p>

                    <div class="mb-4 p-2 light-grey-2-cfa-languedoc-bg text-center">
                        <h2>
                            {{offre.titre_job | uppercase}}
                        </h2>
                        <span *ngIf="offre.secteur_activite">
                            SECTEUR {{offre.secteur_activite | uppercase}}
                        </span>
                        <br>
                        <span *ngIf="offre.ville">
                            À {{offre.ville | uppercase}}
                        </span>
                        <span *ngIf="offre.quartier">
                            (QUARTIER {{offre.quartier | uppercase}})
                        </span>
                    </div>

                    <div class="info mb-4">
                        <div class="info__text">
                            <div class="info__text__item">
                                <span class="info__text__item__key">
                                    Service :
                                </span>
                                <span class="info__text__item__value">
                                    {{offre.service_poste}}
                                </span>
                            </div>
                            <br>
                            <div class="info__text__item">
                                <span class="info__text__item__key">
                                    Contrat en apprentissage :
                                </span>
                                <span class="info__text__item__value">
                                    - Contrat de {{offre.duree_mission}} <br>
                                    - {{offre.jours_presence}} jour{{offre.jours_presence > 1 ? 's' : ''}} ({{offre.temps_travail}}h) par semaine en entreprise <br>
                                    - le reste du temps en formation {{offre.formation}}
                                </span>
                            </div>

                        </div>

                        <img [src]="'https://www.apprentissage-montpellier.education/img/offres-emploi/' + offre.illustration" class="info__img">
                    </div>

                    <p class="mb-4">
                        <span class="post">
                            VOTRE POSTE :
                        </span>
                    </p>

                    <div style="line-height: 1.3;" [innerHTML]="offre.descriptif_poste"></div>

                    <div class="info my-4">
                        <div class="info__text">
                            <div class="info__text__item">
                                <span class="info__text__item__key">
                                    Permis B requis :
                                </span>
                                <span class="info__text__item__value">
                                    {{offre.vehicule_obligatoire > 0? 'Oui' : 'Non'}}
                                </span>
                            </div>
                            <div class="info__text__item">
                                <span class="info__text__item__key">
                                    Prise de poste :
                                </span>
                                <span class="info__text__item__value">
                                    {{offre.date_debut_mission | date:'longDate':'fr'}}
                                </span>
                            </div>
                            <div class="info__text__item">
                                <span class="info__text__item__key">
                                    Référence :
                                </span>
                                <span class="info__text__item__value">
                                    {{offre.reference}}
                                </span>
                            </div>

                        </div>
                    </div>

                    <div class="col-12 col-sm-7 col-md-6 col-lg-7 text-center my-5 button-div">
                        <a class="bouton-inscription col-12" [routerLink]="['/postuler', offre.id_offre_emploi]"> JE POSTULE </a>
                    </div>

                </div>

                <div class="hide-on-small-and-medium col-lg-3">

                    <ng-container *ngFor="let pave of paves">
                        <a [href]="pave.url_destination" class="no-underline" [target]="pave.nouvel_onglet === '1' ? '_blank' : '_self'">
                            <div class="mb-4 mt-4 pave ombre-clickable">
                                <div class="pave__haut" [style.backgroundColor]="pave.couleur_fond_haut">
                                    <p class="pave__haut__text" [style.color]="pave.couleur_texte_haut" [innerHTML]="pave.html_div_haut"></p>
                                    <img class="pave__haut__img" [src]="'https://www.apprentissage-montpellier.education/img/paves/' + pave.image_haut_droite">
                                </div>
                                <div class="pave__bas" [style.backgroundColor]="pave.couleur_fond_bas">
                                    <p class="pave__bas__text" [style.color]="pave.couleur_texte_bas" [innerHTML]="pave.html_div_bas"></p>
                                    <img class="pave__bas__img" [src]="'https://www.apprentissage-montpellier.education/img/paves/' + pave.image_bas_droite">
                                </div>
                            </div>
                        </a>
                    </ng-container>

                </div>

            </div>

        </div>
    </div>
</div>